// Event delegation so it also works for promocodes rendered after load
// (e.g. product cards re-rendered by facet filtering on the PLP).
document.addEventListener('click', function (e) {
  const promocode = e.target.closest('.promocode');
  if (!promocode) return;

  e.preventDefault();

  const value = promocode.getAttribute('data-value');
  if (!value) return;

  navigator.clipboard
    .writeText(value)
    .then(function () {
      promocode.classList.add('copied');
      setTimeout(function () {
        promocode.classList.remove('copied');
      }, 2000);
    })
    .catch(function () {});
});
